function isIos13Ipad(): boolean {
  if (!window.navigator) {
    return false;
  }
  return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
}

export default {
  isIos13Ipad: isIos13Ipad()
};
